module.exports = __webpack_public_path__ + "img/A58A0568.2489f268.jpg";